import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
const SETTING_CHANGED = 'taskSettingsChanged';
const ACTIONS = {
  FOLLOW_UP_REMINDER_CHANGED: 'followUpReminderToggled',
  DEFAULT_DUE_DATE_PRESET_CHANGED: 'defaultDueDatePresetChanged',
  DEFAULT_DUE_TIME_CHANGED: 'defaultDueTimeChanged',
  DEFAULT_REMINDER_PRESET_CHANGED: 'defaultReminderPresetChanged',
  LEAD_FOLLOW_UP_REMINDER_CHANGED: 'leadFollowUpReminderToggled'
};
export const tracker = createTracker({
  events
});
function trackSettingChanged(action, extraProperties = {}) {
  const {
    value
  } = extraProperties;
  tracker.track(SETTING_CHANGED, {
    action,
    value: String(value)
  });
}
export function trackFollowUpReminderSettingChanged(value) {
  return trackSettingChanged(ACTIONS.FOLLOW_UP_REMINDER_CHANGED, {
    value
  });
}
export function trackLeadFollowUpReminderSettingChanged(value) {
  return trackSettingChanged(ACTIONS.LEAD_FOLLOW_UP_REMINDER_CHANGED, {
    value
  });
}
export function trackDueDatePresetSettingChanged(value) {
  return trackSettingChanged(ACTIONS.DEFAULT_DUE_DATE_PRESET_CHANGED, {
    value
  });
}
export function trackDueTimeSettingChanged(value) {
  return trackSettingChanged(ACTIONS.DEFAULT_DUE_TIME_CHANGED, {
    value
  });
}
export function trackReminderPresetSettingChanged(value) {
  return trackSettingChanged(ACTIONS.DEFAULT_REMINDER_PRESET_CHANGED, {
    value
  });
}